import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  InventorySourceSystem,
  InventoryStatus,
} from '@usf/inventory-types/inventory/index';
import { SortableSectionHeader } from '../../../shared/components/sortable-section/models/sortable-section.model';
import {
  InventoryCardEllipsisClick,
  InventoryViewModel,
} from '../../models/inventory-view.model';

@Component({
  template: '',
})
export class InventorySectionBaseComponent {
  @Input() sectionHeaders: SortableSectionHeader[];
  @Input() selectedHeader: string;
  @Input() inventories: InventoryViewModel[];
  @Input() isInventoryLanding: boolean;
  @Input() searchKey: string;
  @Input() tabletHeaderButtonText?: string;

  @Output()
  updateSortEmitter: EventEmitter<SortableSectionHeader> = new EventEmitter();
  @Output() openWorksheetEmitter: EventEmitter<string> = new EventEmitter();
  @Output()
  inventoryEllipsisEmitter: EventEmitter<InventoryCardEllipsisClick> = new EventEmitter();
  @Output()
  copyInventoryEmitter: EventEmitter<string> = new EventEmitter();

  InventoryStatus = InventoryStatus;
  InventorySourceSystem = InventorySourceSystem;

  constructor() {}

  updateInventoriesSort(event: SortableSectionHeader) {
    this.updateSortEmitter.emit(event);
  }

  openInventoryWorksheet(event: Event, path: string) {
    event.stopPropagation();
    this.openWorksheetEmitter.emit(path);
  }

  openInventoryOptions(event: Event, inventory: InventoryViewModel) {
    event.stopPropagation();
    this.inventoryEllipsisEmitter.emit({
      event,
      inventory,
    });
  }

  copyInventory(event: Event, inventoryId: string) {
    event.stopPropagation();
    this.copyInventoryEmitter.emit(inventoryId);
  }

  trackItem(index: any, item: any) {
    return item ? index : undefined;
  }
}
